import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class ErgaenzungWerteStromerzeugung extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    jahr: number | null = null;
    kanton_id: number | null = null;
    gemeinde_id: number | null = null;
    referenz: string | null = null;
    egid: number | null = null;
    produktionsanlage: string | null = null;
    technologie_stromerzeugung_id: number | null = null;
    inbetriebnahme: Dayjs | null = null;
    leistung: number | null = null;
    produktion: number | null = null;
    bemerkung: string | null = null;

    // view fields
    kanton_kuerzel: string | null = null;
    kanton: string | null = null;
    gemeinde: string | null = null;
    technologie_stromerzeugung: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
            inbetriebnahme: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'ErgaenzungWerteStromerzeugung';
    }
}

export async function createNewErgaenzungWerteStromerzeugung(): Promise<ErgaenzungWerteStromerzeugung> {
    const ergaenzungwertestromerzeugung = createModel(ErgaenzungWerteStromerzeugung, {});

    await ergaenzungwertestromerzeugung.save();
    return ergaenzungwertestromerzeugung;
}

export class ErgaenzungWerteStromerzeugungCollection extends BaseCollection<ErgaenzungWerteStromerzeugung> {
    protected modelCls = ErgaenzungWerteStromerzeugung;

    public getModelClassName(): string {
        return 'ErgaenzungWerteStromerzeugung';
    }
}
